'use strict';

export default class {
  /*@ngInject*/
  constructor(
    $http,
    $filter,
    ColorFinder,
    DateFinder,
    ValidIndexes,
    Modal,
    $scope,
    $timeout,
  ) {
    this.$http = $http;
    this.$filter = $filter;
    this.ColorFinder = ColorFinder;
    this.DateFinder = DateFinder;
    this.ValidIndexes = ValidIndexes;
    this.star = "fa fa-star";
    this.Modal = Modal;
    this.$scope = $scope;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.loaded = 0;
    this.success = false;
    this.fail = false;

    this.$http.get("/api/price").then((response) => {
      this.prices = response.data.map((price) => price.value);
    });

    this.$http.get("/api/students").then((response) => {
      this.students = response.data;
      this.finishedLoad();
    });

    this.$http.get("/api/icons").then((response) => {
      this.icons = response.data[0] || {
        first: "",
        second: "",
        third: "",
        fourth: "",
        fifth: "",
        sixth: "",
        year12: "",
        xero: "",
        _note: "",
        _tempUnknown: "", // no proper labels given as this is for futre use
        _permUnknown: "",
        _perm2Unknown: "",
        _perm3Unknown: "",
        _perm4Unknown: "",
        _perm5Unknown: "",
      };
      this.finishedLoad();
    });
    this.$http.get("/api/termsettings").then((response) => {
      if (response && response.data && response.data[0]) {
        this.term = {
          _id: response.data[0]._id,
          termNo: response.data[0].termNo,
          startDate: parseInt(response.data[0].startDate, 10),
          endDate: parseInt(response.data[0].endDate, 10),
          sixthSunday: response.data[0].sixthSunday,
        };
      } else {
        this.term = {
          termNo: "",
          startDate: "",
          endDate: "",
          sixthSunday: "",
        };
      }
      this.finishedLoad();
    });
    this.$http.get("/api/lessons").then((response) => {
      this.sessions = response.data;
      this.finishedLoad();
    });
    this.isSandbox =
      location.host.includes("sandbox") || location.host.includes("8082");
    this.loading = true;
  }

  finishedLoad() {
    this.loaded++;
    if (this.loaded === 4) {
      this.loading = false;
    }
  }

  resetDatabase() {
    if (window.confirm("Are you sure you want to refresh the database?")) {
      this.$http.get("/api/users/new-database");
    }
  }

  addYear() {
    if (window.confirm("Are you sure you want to do this?")) {
      this.students.forEach((student) => {
        //If student is not in uni
        if (!student.isTertiary) {
          if (student.grade === 12) {
            student.isTertiary = true;
            student.isActive = false;
          } else {
            student.grade++;
          }
          //now save student
          this.$http.put(`/api/students/${student._id}`, student);
        }
      });
    }
  }

  saveIcons() {
    this.iconSuccess = false;
    this.iconFail = false;
    if (this.icons._id) {
      this.$http
        .put(`/api/icons/${this.icons._id}`, this.icons)
        .then(() => {
          this.iconSuccess = true;
        })
        .catch(() => {
          this.iconFail = true;
        });
    } else {
      this.$http
        .post("/api/icons", this.icons)
        .then(() => {
          this.iconSuccess = true;
        })
        .catch(() => {
          this.iconFail = true;
        });
    }
  }

  updateSettings() {
    this.success = false;
    this.fail = false;
    this.term.startDate = new Date(this.term.startDate).getTime();
    this.term.endDate = new Date(this.term.endDate).getTime();
    if (this.term._id) {
      this.$http
        .put(`/api/termsettings/${this.term._id}`, this.term)
        .then(() => {
          this.term.success = true;
        })
        .catch(() => {
          this.term.fail = true;
        });
    } else {
      this.$http
        .post("/api/termsettings", this.term)
        .then(() => {
          this.term.success = true;
        })
        .catch(() => {
          this.term.fail = true;
        });
    }

    this.getWeekendsOfTerm();
  }

  generateEmails() {
    if (window.confirm("Are you sure you want to send student e-mails?")) {
      // this.loading = true;
      var start = new Date(this.term.startDate);
      var end = new Date(this.term.endDate);
      var termNo = this.term.termNo;
      var sixthSunday = this.term.sixthSunday;
      var studentIds = this.getStudentIds();
      var studentSessions = this.sessions.filter((session) =>
        studentIds.has(session.clientUID),
      );
      var sessionData = [];
      studentSessions.forEach((session) => {
        const validIndexes = this.ValidIndexes(session, start, end);
        var specificNotes = "";
        if (session.overwriteNotes) {
          Object.values(session.overwriteNotes).forEach((val) => {
            if (val) {
              specificNotes += `\n${val}`;
            }
          });
        }
        validIndexes.forEach((index) => {
          if (session.clientUID) {
            const sessionDate = this.DateFinder(session, index);
            const formattedDate = this.$filter("toDateString")(sessionDate);
            const parsedDate = this.$filter("reparseDate")(formattedDate);
            const color = this.ColorFinder(session, index);
            sessionData.push({
              clientUID: session.clientUID,
              duration: session.duration,
              overwriteDuration: session.overwriteDuration,
              sessionDate,
              date: parsedDate,
              globalNotes: session.globalNotes,
              specificNotes,
              color,
              location: session.location,
              tutorName: session.tutor ? session.tutor.fullName : "",
            });
          }
        });
      });
      sessionData = sessionData.filter((session) => {
        var acceptedColors = [
          "blue",
          "dark blue",
          "green",
          "dark green",
          "purple",
          "dark purple",
          "orange",
          "dark orange",
          "lime",
          "dark lime",
        ];
        var color = session.color.toLowerCase();
        if (color.overwriteColor) {
          var overwriteColor = session.overwriteColor[0].toLowerCase();
          return (
            acceptedColors.includes(color) ||
            acceptedColors.includes(overwriteColor)
          );
        } else {
          return acceptedColors.includes(color);
        }
      });
      sessionData = sessionData.sort((a, b) => {
        if (a.sessionDate < b.sessionDate) {
          return -1;
        }
        if (a.sessionDate > b.sessionDate) {
          return 1;
        }
        if (a.basicTime < b.basicTime) {
          return -1;
        }
        if (a.basicTime > b.basicTime) {
          return 1;
        }
        return 0;
      });

      var studentsData = [];
      var weekEnderResults = this.getWeekendsOfTerm();
      studentIds.forEach((sID) => {
        var sessionsForStudent = sessionData.filter(
          (session) => session.clientUID === sID,
        );
        let weekListInfo = this.retrieveHoursPerWeek(
          weekEnderResults,
          sessionsForStudent,
        );
        var student = this.students.find((s) => s._id === sID);
        if (student) {
          studentsData.push({
            clientEmailAddress: student.clientEmail.toLowerCase(),
            clientName: student.clientFirstName,
            clientLastName: student.clientLastName,
            studentName: student.firstName,
            mobileNumber: student.clientPh,
            termNo,
            sixthSunday,
            hoursCompleted: weekListInfo.hoursCompleted,
            hoursToFinish: 10 - weekListInfo.hoursCompleted,
            weekList: weekListInfo.weekList,
          });
        }
      });

      studentsData = studentsData
        .filter((s) => s.clientEmailAddress !== "contact@gspt.com.au")
        .sort((a, b) => {
          if (a.clientEmailAddress < b.clientEmailAddress) {
            return -1;
          }
          if (a.clientEmailAddress > b.clientEmailAddress) {
            return 1;
          }
          return 0;
        });
      console.log(studentsData.length);

      studentsData.forEach((studentInfo) => {
        this.$http
          .post("/api/students/send-email-notif", {
            subject: `Tuition Schedule to Finish Term ${termNo}`,
            studentInfo: [studentInfo],
          })
          .then(() => {
            console.log("success");
          })
          .catch(() => {
            console.log("error");
          });
      });
      console.log("reached end of generate emails");
    }
  }

  retrieveHoursPerWeek(weekEnderResults, sessionData) {
    var weekListInfo = {
      hoursCompleted: 0,
      weekList: [],
    };

    weekEnderResults.forEach((weekend, i, weekends) => {
      var weekendDate = new Date(weekend.value);
      weekend.duration = 0;
      var setNotes = new Set();
      sessionData.forEach((session) => {
        weekend.tutorName = session.tutorName;
        weekend.location = session.location;
        if (session.globalNotes) {
          setNotes.add(session.globalNotes);
        }
        weekend.specificNotes = session.specificNotes;
        var duration = session.duration / 60;
        if (typeof session.overwriteDuration === "object") {
          var index = (i + 1).toString();
          if (session.overwriteDuration.hasOwnProperty(index)) {
            duration = session.overwriteDuration[index] / 60;
          }
        }
        let sessionDate = new Date(session.date);
        if (i === 0 && sessionDate <= weekendDate) {
          weekend.duration += duration;
        } else if (i > 0) {
          var weekendStart = new Date(weekends[i - 1].value);
          if (sessionDate > weekendStart && sessionDate <= weekendDate) {
            weekend.duration += duration;
          }
        }
      });
      var month = `0${weekendDate.getMonth() + 1}`.slice(-2);
      var date = `0${weekendDate.getDate()}`.slice(-2);
      var year = weekendDate.getFullYear();
      var status = i > 4 ? "Scheduled" : "Completed";
      var toBeRescheduled = false;
      if (i >= 0 && i <= 4) {
        weekListInfo.hoursCompleted += weekend.duration;
        if (weekend.duration === 0) {
          status += " (To Be Rescheduled)";
          toBeRescheduled = true;
        }
      } else if (i === 9) {
        status += "  (Does This Session Need To Be Rescheduled?)";
      }
      weekListInfo.weekList.push({
        location: weekend.location,
        tutorName: weekend.tutorName,
        globalNotes: Array.from(setNotes),
        specificNotes: weekend.specificNotes,
        duration: weekend.duration,
        date: `${date}/${month}/${year}`,
        value: `Week Ending ${date}/${month} - ${weekend.duration} Hour ${status}`,
        toBeRescheduled,
      });
    });
    return weekListInfo;
  }

  getStudentIds() {
    var weekEnderResults = this.getWeekendsOfTerm();
    var start = new Date(weekEnderResults[4].value);
    start.setDate(start.getDate() + 1);
    var end = new Date(weekEnderResults[5].value);

    console.log(`Start date: ${start}`);
    console.log(`End date: ${end}`);

    var studentIds = [];
    var sessions = this.sessions.map((session) => {
      if (!session.student && session.clientUID) {
        session.student = this.students.find(
          (s) => s._id === session.clientUID,
        );
      }
      return session;
    });
    sessions.forEach((session) => {
      const validIndexes = this.ValidIndexes(session, start, end);
      validIndexes.forEach(() => {
        // console.log(session)
        // const sessionDate = session.date ? this.DateFinder(session, index) : null;
        // const formattedDate = this.$filter('toDateString')(sessionDate);
        // const parsedDate = this.$filter('reparseDate')(formattedDate);
        // const color = this.ColorFinder(session, index);
        studentIds.push(session.clientUID);
      });
    });

    studentIds = new Set(studentIds.sort());
    var studentEmailInfo = [];
    studentIds.forEach((studentId) => {
      var student = this.students.find((s) => s._id === studentId);
      if (student) {
        studentEmailInfo.push({
          clientEmailAddress: student.clientEmail,
          clientName: student.clientFirstName,
          studentName: student.firstName,
        });
      }
    });
    return studentIds;
  }

  getWeekendsOfTerm() {
    var start = new Date(this.term.startDate);
    var end = new Date(this.term.endDate);
    var weekEnderResults = [];
    var day = 0;
    var current = new Date(start);
    current.setDate(current.getDate() + ((day - current.getDay() + 7) % 7));
    end.setDate(end.getDate() + ((7 - end.getDay()) % 7));
    while (current <= end) {
      var weekEnder = new Date(+current);
      weekEnderResults.push({
        value: weekEnder,
        duration: 0,
      });
      current.setDate(current.getDate() + 7);
    }
    return weekEnderResults;
  }

  openCostSettingsModal() {
    return this.Modal.costSettings().result.then((result) => {
      if (result.type === "created") {
        this.successMessage = `Price ${result.price} added successfully.`;
      }

      if (result.type === "updated") {
        this.successMessage = `${result.updatedCount} student prices updated from ${result.oldValue} to ${result.newValue}.`;
      }

      this.success = true;

      this.$timeout(() => {
        this.success = false;
      }, 3000);
    });
  }

  updatePrice() {
    this.priceError = "";
    const oldValue = this.oldPrice;
    const newValue = this.newPrice;

    this.$http
      .put("/api/students/update-price", {
        oldValue: oldValue,
        newValue: newValue,
      })
      .then((response) => {
        this.$scope.$close({
          type: "updated",
          oldValue,
          newValue,
          updatedCount: response.data.nModified,
        });
      })
      .catch((err) => {
        this.priceError = "Unable to update price.";
        this.fail = true;
        this.$timeout(() => {
          this.fail = false;
        }, 3000);
      });
  }

  createPrice() {
    this.priceError = "";
    const checkSet = new Set(this.prices);

    if (!this.newPriceToAdd) {
      this.priceError = "Please enter a price.";
      return;
    }

    if (this.newPriceToAdd <= 0) {
      this.priceError = "Price must be greater than $0.";
      return;
    }

    if (checkSet.has(`$${this.newPriceToAdd}`)) {
      this.priceError = "This price already exists.";
      return;
    }

    this.$http
      .post("/api/price/create", {
        value: `$${this.newPriceToAdd}`,
      })
      .then((response) => {
        this.$scope.$close({
          type: "created",
          price: response.data.value,
        });
      })
      .catch((err) => {
        this.priceError = "Unable to create price.";
      });
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/settings/settings.controller.js